<template lang="html">
    <section class="governmental">
        <nav class="content container">
            <article>
                <img src="/static/img/governmental/ministerio_logo.png" />
            </article>
            <article>
                <img src="/static/img/governmental/camara_logo.png" />
            </article>
            <article>
                <img src="/static/img/governmental/plan_logo.png" />
            </article>
            <article>
                <img src="/static/img/governmental/nextG_logo.png" />
            </article>
        </nav>
    </section>
</template>

<script lang="js">
export default {
    name: 'governmental'
}
</script>

<style scoped lang="scss">
.governmental {
    width: 100%;
    height: 100%;
    background-color: white;
    padding-top: 20px;
    padding-bottom: 20px;
    .content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        img {
        max-width: 200px;
        max-height: 50px;
        object-fit: cover;
        }
    }
}

@media screen and (max-width: 992px) {

    .governmental .content img {
        max-width: 120px;
    }
}

@media screen and (max-width: 524px) {
    .governmental {
        overflow: scroll !important;
        justify-content: start !important;

        .content img {
            max-width: 100px !important;
            margin-right: 10px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/parts/governmental.vue